import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../../lib/router/withRouter';
import { recommendSearchWordActions } from '../../../store/modules/recommend/searchWord';
import RecommendSearchWordDetailWrap from '../../../views/recommend/searchWord/detail/RecommendSearchWordDetailWrap';

class RecommendSearchWordDetailContainer extends Component {
  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = (recommendSearchWordId) => {
    const { getRecommendSearchWordDetail } = this.props;

    getRecommendSearchWordDetail({
      recommendSearchWordId,
    });
  };

  render() {
    const { recommendSearchWordDetail } = this.props;

    return <RecommendSearchWordDetailWrap recommendSearchWordDetail={recommendSearchWordDetail} />;
  }
}

const mapStateToProps = (state) => {
  return {
    recommendSearchWordDetail: state.recommendSearchWord.recommendSearchWordDetail,
  };
};

const mapDispatchToProps = {
  getRecommendSearchWordDetail: recommendSearchWordActions.getRecommendSearchWordDetail,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RecommendSearchWordDetailContainer));
